// 
import React, { useState } from "react";
import grandBallroomImage from "../img/aaaservices/ba1.webp";
import conferenceBanquetImage from "../img/aaaservices/ba2.webp";
import outdoorBanquetImage from "../img/aaaservices/ba3.webp";
import royalBanquetImage from "../img/aaaservices/ba4.webp";
import classicBanquetImage from "../img/aaaservices/ba5.webp";
import miniBanquetImage from "../img/aaaservices/ba6.webp";

const vehicles = [
  { 
    name: "Grand Ballroom", 
    image: grandBallroomImage, 
    features: ["Spacious Hall", "Luxury Chandeliers", "Stage with LED Lighting", "Round Table Seating", "AC", "Premium Sound System"]
  },
  { 
    name: "Conference Banquet Hall", 
    image: conferenceBanquetImage, 
    features: ["Projector & Screen", "Theater-Style Seating", "High-Speed WiFi", "Podium & Mic", "AC", "Coffee & Refreshments"]
  },
  { 
    name: "Outdoor Banquet Hall", 
    image: outdoorBanquetImage, 
    features: ["Garden Setup", "Open-Air Stage", "Weatherproof Canopy", "Fairy Lights & Decorations", "Outdoor Seating", "Buffet Arrangement"]
  },
  { 
    name: "Royal Banquet Hall", 
    image: royalBanquetImage, 
    features: ["Gold & Velvet Decor", "Customizable Lighting", "VIP Lounge Area", "Royal Dining Setup", "AC", "Live Entertainment Option"]
  },
  { 
    name: "Classic Banquet Hall", 
    image: classicBanquetImage, 
    features: ["Elegant Interiors", "Banquet-Style Seating", "Dance Floor", "Decorative Ceilings", "Buffet Area", "AC"]
  },
  { 
    name: "Mini Banquet Hall", 
    image: miniBanquetImage, 
    features: ["Compact & Cozy Setup", "Private Event Space", "Personalized Catering", "Decor Customization", "AC", "WiFi"]
  }
];



const CarFilter = () => {
  const [hoveredVehicle, setHoveredVehicle] = useState(null);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px", fontFamily: "Arial, sans-serif" }}>
      
      {/* Main Container for Vehicles and Form */}
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "30px",
        maxWidth: "1200px",
        width: "100%"
      }}>
        
        {/* Vehicles Grid */}
        <div
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(268px, 1fr))",
    gap: "20px",
    flex: "1",
    minWidth: "300px",
  }}
>
  {vehicles.map((vehicle, index) => (
    <div
      key={index}
      style={{
        position: "relative",
        textAlign: "center",
        overflow: "hidden",
        borderRadius: "10px",
        cursor: "pointer",
      }}
      onMouseEnter={() => setHoveredVehicle(vehicle)}
      onMouseLeave={() => setHoveredVehicle(null)}
    >
      {/* Vehicle Image */}
      <img
  src={vehicle.image}
  alt={vehicle.name}
  style={{
    width: "100%",
    height: "auto",
    borderRadius: "10px",
  }}
/>


      {/* Hover Overlay */}
      <div
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          color: "#fff",
          textAlign: "center",
          padding: "20px",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          opacity: hoveredVehicle === vehicle ? 1 : 0,
          visibility: hoveredVehicle === vehicle ? "visible" : "hidden",
          transition: "opacity 0.4s ease-in-out, visibility 0.4s ease-in-out",
        }}
      >
        <h4>{vehicle.name}</h4>
        <ul
  style={{
    display: "flex",
    flexWrap: "wrap",
    listStyle: "none",
    padding: 0,
    margin: 0,
    gap: "10px",
  }}
>
  {vehicle.features.map((feature, i) => (
    <li
      key={i}
      style={{
        flex: "1 1 calc(50% - 10px)", // Two equal columns on large screens
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        textAlign: "center",
        backgroundColor: "gray", // Red background
        color: "white", // White text for contrast
        fontWeight: "bold",
      }}
    >
      {feature}
    </li>
  ))}
</ul>

<style>
  {`
    @media (max-width: 425px) {
      ul li {
        flex: 1 1 100%; /* Full width for screens up to 425px */
      }
    }

    @media (max-width: 375px) {
      ul li {
        flex: 1 1 100%; /* Full width for screens up to 375px */
        padding: 8px; /* Reduce padding */
        font-size: 14px; /* Adjust font size */
      }
    }
    
    @media (max-width: 320px) {
      ul li {
        flex: 1 1 100%; /* Full width for very small screens (320px) */
        padding: 6px; /* Further reduce padding */
        font-size: 12px; /* Reduce font size for smaller screens */
      }
    }
  `}
</style>




        
      </div>
      
    </div>
  
   
  ))}
{/* 
<div style={{ textAlign: "center", marginTop: "10px" }}>
  <button
    style={{
      padding: "10px 15px",
      backgroundColor: "red",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "16px",
      width: "100%", 
      maxWidth: "200px", 
      display: "block", 
    }}
    onClick={() => window.location.href = `/room-details/${vehicles.name.toLowerCase().replace(/\s+/g, '-')}`}
  >
    Read More
  </button>
</div> */}

</div>


        {/* Enquiry Form */}
        <div className="from-enquery">
  <h3 style={{fontFamily:'roboto',fontWeight:'400'}}>Hotel Booking </h3>
  <form>
    <input type="text" placeholder="Your Name" required />
    <input type="tel" placeholder="Your Phone" required />
    
    <label style={{textAlign:'left'}}>Check-in Date:</label>
    <input type="date" required />
    
    <label style={{textAlign:'left'}}>Check-out Date:</label>
    <input type="date" required />
    
   
    <input type="number" min="1" placeholder="Number of Adults" required />
    
   
    <input type="number" min="0" placeholder="Number of Children" />
    
   
    <input type="number" min="1" placeholder="Number of Rooms" required />
    
    <textarea placeholder="Special Requests (Optional)"></textarea>
    
    <button type="submit">Submit Booking Enquiry</button>
  </form>
</div>

<style>
  {`
    .from-enquery {
      width: 350px;
      padding: 20px;
      background-color: #f9f9f9;
      border-radius: 8px;
      box-shadow: 0px 0px 10px rgba(0,0,0,0.1);
      flex-shrink: 0;
      min-width: 300px;
      text-align: center;
    }

    .from-enquery h3 {
      color: #ffca00;
    }

    .from-enquery form {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .from-enquery input, .from-enquery textarea {
      padding: 8px;
      border-radius: 4px;
      border: 1px solid #ccc;
      width: 100%;
    }

    .from-enquery button {
      padding: 10px;
      background-color: #ffcc00;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-weight: bold;
    }

    /* Media Queries */
    @media (max-width: 600px) {
      .from-enquery {
        width: 300px;
      }
    }

    @media (max-width: 425px) {
      .from-enquery {
        width: 284px;
      }
    }

    @media (max-width: 375px) {
      .from-enquery {
        width: 284px;
      }
    }

    @media (max-width: 320px) {
      .from-enquery {
        width: 284px;
        padding: 15px;
      }
    }
  `}
</style>


      </div>

    </div>
  );
};

export default CarFilter;